module.exports = __webpack_public_path__ + "img/wheel_back.47d53a0e.gif";